<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  body {
    background-color: #9E9E9E;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    color: #6D6D6D;
    font-size: 18px;
    line-height: 1.5em;
    text-shadow: 0.55px 0.55px 0.55px #fff, -0.55px -0.55px 0.55px #000;
  }

  #app {
    font-family: Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    overflow-x: hidden;
    padding-bottom: 0px;
  }
  .light-but {
    margin-top: 10px;
    opacity: 1;
    float: left;
    position: relative;
    width: 130px;
  }
  .light-but.right-float {
    float: right;
  }
  .dissar-active .dissa {
    opacity: 0;
    transition: opacity 0.7s ease;
  }
  .dissa {
    opacity: 1;
    transition: opacity 0.7s ease;
  }
  .smallerp {
    font-size: 0.8em;
    line-height: 1.3em;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue